import { Slide } from "@jelly/lesson";
import theory from "../../theory";

import { component as livingRoom07 } from "./components/living-room-0.7s";
import { component as livingRoom10 } from "./components/living-room-1.0s";
import { component as livingRoom20 } from "./components/living-room-2.0s";
import { component as smallAuditorium07 } from "./components/small-auditorium-0.7s";
import { component as smallAuditorium10 } from "./components/small-auditorium-1.0s";
import { component as smallAuditorium20 } from "./components/small-auditorium-2.0s";
import { component as concertHall07 } from "./components/concert-hall-0.7s";
import { component as concertHall10 } from "./components/concert-hall-1.0s";
import { component as concertHall20 } from "./components/concert-hall-2.0s";

const principle: Slide = {
  title: "",
  description:
    "To hear how different sources sound in rooms with different reverberation time and volume, change these parameters and listen to the corresponding sound samples. Choose a setting you prefer for a given sound source (there are no right or wrong answers). Also notice how the sound level varies strongly when changing the parameters. This is because the loudness of the samples is calibrated relatively between them. Please do not set the volume on your headphones too high. Lp,Rev values indicated in orange are very loud.",
  theory: theory,
  layout: {
    type: "controlsToggleExtraContent",
    options: {
      controlsPosition: "bottom",
      controls: [
        {
          type: "dropdown",
          options: {
            label: "Room size",
          },
          items: [
            { name: "Living room: 30m<sup>2</sup> (100 m<sup>3</sup>)" },
            { name: "Small auditorium : 250m<sup>2</sup> (1000 m<sup>3</sup>)" },
            { name: "Concert hall: 10000 m<sup>3</sup>" },
          ],
        },
        {
          type: "dropdown",
          options: {
            label: "Reverberation time",
          },
          items: [{ name: "0.7 s" }, { name: "1.0 s" }, { name: "2.0 s" }],
        },
      ],
      extraContent: [
        [[], [], []],
        [[], [], []],
        [[], [], []],
      ],
      components: [
        [[livingRoom07], [livingRoom10], [livingRoom20]],
        [[smallAuditorium07], [smallAuditorium10], [smallAuditorium20]],
        [[concertHall07], [concertHall10], [concertHall20]],
      ],
    },
  },
};

export default principle;
